import YieldManagerBidStat from '@/common/models/yieldManager/YieldManagerBidStat';

interface IYieldManagerBidStatsApi {
  overall?: any;
  [key: string]: any;
}

interface IYieldManagerBidStats {
  overall: any;
  bySsp: any[];
}

export default class YieldManagerBidStats {
  overall: any | null;
  bySsp: any[];

  constructor({ overall, bySsp }: { overall: any | null; bySsp: any[] } = { overall: null, bySsp: [] }) {
    this.overall = overall;
    this.bySsp = bySsp;
  }

  applyPreviousPeriod(stats: IYieldManagerBidStats): void {
    this.overall.previousPeriodStats = stats.overall;
    this.bySsp.forEach((ssp) => {
      ssp.previousPeriodStats = stats.bySsp.find((x) => x.id === ssp.id);
    });
  }

  static fromApi(apiModel: IYieldManagerBidStatsApi): YieldManagerBidStats {
    let overall = null;
    if (apiModel.overall) {
      overall = YieldManagerBidStat.fromApi('overall', apiModel.overall);
    }
    const bySsp = Object.keys(apiModel)
      .filter((x) => x !== 'overall')
      .map((x) => YieldManagerBidStat.fromApi(x, apiModel[x]));
    return new YieldManagerBidStats({ overall, bySsp });
  }
}
